// icons
import { FiX } from "react-icons/fi";
// link
import { Link } from "react-router-dom";
// useFetch hook
import useFetch from "../hook/useFetch";

export default function CategoryNavMobile({ setCatnavMobile }) {
  // get categories
  const { data } = useFetch("/categories");
  return (
    <div className="w-full h-full bg-canvas p-8 border-r border-border">
      <div className="flex justify-end mb-8">
        <button
          type="button"
          onClick={() => setCatnavMobile(false)}
          aria-label="Close categories menu"
          className="text-ink hover:text-brand transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded">
          <FiX className="text-3xl" />
        </button>
      </div>
      <div className="flex flex-col gap-y-8">
        {data?.map((category) => {
          return (
            <Link
              to={`/products/${category.slug}`}
              onClick={() => setCatnavMobile(false)}
              className="uppercase font-medium text-ink hover:text-brand transition-colors"
              key={category._id}>
              {category.title} Cameras
            </Link>
          );
        })}
      </div>
    </div>
  );
}
